<template>
  <div class="projectDeviceCopy">
    <div class="projectDeviceContent">
      <div class="searchBox">
        <el-form>
          <div class="searchPox" style="width: 100%;display: flex;justify-content: space-between;align-items: center">
            <div style="display: flex;align-items: center">
              <el-select v-model="searchSelect1" style="width: 100px;margin-right: 8px">
                <el-option v-if="activeName===1" label="通讯地址" value="1"></el-option>
                <el-option label="设备名称" value="2"></el-option>
                <el-option v-if="activeName===1" label="产品型号" value="3"></el-option>
              </el-select>
              <div v-if="activeName===1" v-show="searchSelect1==3" class="liBox">
                <el-form-item label="">
                  <el-input v-model="productModel" autocomplete="off" clearable placeholder='请输入产品型号'
                            type="text"></el-input>
                </el-form-item>
              </div>
              <div v-show="searchSelect1==2" class="liBox">
                <el-form-item label="">
                  <el-input v-model="name" autocomplete="off" clearable placeholder='请输入设备名称' type="text"
                            @change="nameChange"></el-input>
                </el-form-item>
              </div>
              <div v-if="activeName===1" v-show="searchSelect1==1" class="liBox">
                <el-form-item label="">
                  <el-input v-model="address" autocomplete="off" clearable placeholder='请输入通讯地址' type="text"></el-input>
                </el-form-item>
              </div>
              <el-button class="searchButton" style="margin-right: 16px" type="primary" @click="getListFun">查询
              </el-button>
              <div v-if="activeName===1" class="liBox" style="width: 252px">
                <el-form-item label="设备状态">
                  <!--                <el-select v-model="useStatus" clearable placeholder="请选择" style="width:100%" @change="getListFun">-->
                  <!--                  <el-option label="全部" value=""></el-option>-->
                  <!--                  <el-option label="在线" value="1"></el-option>-->
                  <!--                  <el-option label="离线" value="0"></el-option>-->
                  <!--                </el-select>-->
                  <el-radio-group v-model="useStatus" @change="getListFun">
                    <el-radio value="">全部</el-radio>
                    <el-radio value="1">在线</el-radio>
                    <el-radio value="0">离线</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <el-checkbox v-model="getSubFlag" label="显示下级" size="large" style="margin-right: 16px;"
                           @change="showNextLevel"/>
              <el-popover popper-class="moreOpera2" trigger="hover">
                <div class="listPox">
                  <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false"
                             @click="addClick()">新建设备
                  </el-button>
                  <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false"
                             @click="bindClick()">绑定设备
                  </el-button>
                  <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false"
                             @click="importClick()">导入设备
                  </el-button>
                  <el-button @click="exportClick()">导出设备</el-button>
                  <el-button v-if="delDeviceLimit" :disabled="custerObj.nodeType==2?true:false"
                             @click="batchDelClick()">批量删除
                  </el-button>
                  <el-button v-if="delDeviceLimit" :disabled="custerObj.nodeType==2?true:false"
                             @click="removeClick()">批量解绑
                  </el-button>
                </div>
                <template #reference>
                  <el-button style="border: 0;background: rgba(22, 93, 255, .1);color: #165DFF;">操作</el-button>
                </template>
              </el-popover>
              <el-popover popper-class="moreOpera2" trigger="hover">
                <div class="listPox">
                  <el-button @click="bindGroupClick('1')">峰谷</el-button>
                  <el-button @click="bindGroupClick('2')">电价</el-button>
                </div>
                <template #reference>
                  <el-button style="border: 0;background: rgba(22, 93, 255, .1);color: #165DFF;">设置</el-button>
                </template>
              </el-popover>
            </div>

            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/screenIcon.png"
                 style="width: 32px;height: 32px"
                 @click="enterFullScreen()">


            <div v-if="false" class="liBox searchBtn">
              <!--              <el-button class="searchButton" type="primary" @click="getListFun">查询</el-button>-->
              <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false" :icon="Plus" type="primary"
                         @click="addClick()">
                新建设备
              </el-button>
              <!--              <el-button type="primary">-->
              <!--                <el-checkbox v-model="getSubFlag" label="" size="large" @change="showNextLevel"/>-->
              <!--                显示下级-->
              <!--              </el-button>-->
              <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false" type="primary"
                         @click="bindClick()">绑定设备
              </el-button>
              <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false" type="primary"
                         @click="importClick()">导入设备
              </el-button>
              <el-button type="primary" @click="exportClick()">导出设备</el-button>
              <div style="display: none;">
                <!--                <el-upload v-model:file-list="fileList" :auto-upload="false" :data="personData" :show-file-list="false"-->
                <!--                           accept=".xls,.xlsx" action="#" class="upload-demo" @change="uploadFile">-->
                <!--                  <button id="fileName" slot="trigger" class="selectFile" size="small" type="primary">选择文件</button>-->
                <!--                </el-upload>-->
                <el-upload v-model:file-list="fileList" :auto-upload="false" :show-file-list="false" accept=".xls,.xlsx"
                           action="#" class="upload-demo"
                           @change="uploadFile2">
                  <el-button id="fileName" style="margin: 0 12px;" type="primary" @click="">
                    导入
                  </el-button>
                </el-upload>
              </div>
              <el-button style="margin-left: 12px;" type="primary"
                         @click="bindGroupClick('1')">
                绑定峰谷、电价
              </el-button>
              <!--              <el-button style="margin-left: 12px;" type="primary"-->
              <!--                         @click="bindWarnClick()">-->
              <!--                批量添加告警-->
              <!--              </el-button>-->
              <el-button v-if="delDeviceLimit" :disabled="custerObj.nodeType==2?true:false" style="margin-left: 12px;"
                         @click="batchDelClick()">
                批量删除
              </el-button>
              <el-button v-if="delDeviceLimit" :disabled="custerObj.nodeType==2?true:false" style="margin-left: 12px;"
                         @click="removeClick()">
                批量解绑
              </el-button>
              <el-button @click="enterFullScreen()">全屏展示</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="tableBox">
        <!--列表-->
        <div class="tableBox">
          <el-table ref="multipleTableRef" v-loading='deviceLoading' :data="deviceList" :row-key="rowKey2"
                    style="width: 100%" table-layout="auto"
                    @selection-change="handleSelectionChange">
            <template #empty>
              <el-empty class="emptyClass" description="暂无数据信息" image="
https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
                <p>您可以在此页面绑定设备</p>
              </el-empty>
            </template>
            <el-table-column :reserve-selection="true" type="selection" width="55"/>
            <el-table-column label="设备名称" min-width="150px" prop="equipmentName"/>
            <el-table-column label="设备地址" min-width="150px" prop="equipmentAddress"/>
            <el-table-column label="网关" min-width="150px" prop="gatewayAddress"/>
            <el-table-column label="状态" min-width="150px" property="useStatusStr">
              <template #default="scope">
                <div v-show="scope.row.useStatus==1" class='statusOnClass'>
                  <div class="dotOnClass"></div>
                  {{ scope.row.useStatusStr }}
                </div>
                <div v-show="scope.row.useStatus==0" class='statusOutClass'>
                  <div class="dotOutClass"></div>
                  {{ scope.row.useStatusStr }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="产品型号" min-width="150px" prop="productModel"/>
            <el-table-column label="创建人" min-width="150px" prop="creatorName"/>
            <el-table-column label="最后通讯时间" min-width="150px" prop="createTime" sortable/>
            <el-table-column fixed="right" label="操作" width="150">
              <template #default="scope">
                <ul v-if="activeName==3" class="operationUl">
                  <li v-show="custerObj.nodeType!=2">
                    <el-tooltip :content="scope.row.switch?'停止':'启动'" class="box-item" effect="dark">
                      <el-switch v-model="scope.row.switch" style="--el-switch-on-color: #ccefe3;"
                                 @change="isOpenChange($event,scope.row)"/>
                    </el-tooltip>
                  </li>
                  <li class="editClass" @click="managementClick(scope.row.id,scope.row.idStr,scope.row.equipmentName)">
                    <el-tooltip content="数据" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear2.png">
                    </el-tooltip>
                  </li>
                  <li v-if="editDeviceLimit" class="editClass" @click="eleSetClick(scope.row)">
                    <el-tooltip content="编辑" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear1.png">
                    </el-tooltip>
                  </li>
                  <li v-if="editDeviceLimit" v-show="custerObj.nodeType!=2" class="editClass"
                      @click="editClick(scope.row)">编辑
                  </li>
                  <li v-show="custerObj.nodeType!=2">
                    <el-popover popper-class="moreOpera" trigger="click">
                      <div class="listPox">
                        <p @click='deviceDetailClick(2,scope.row.equipmentName,scope.row.plugin2,scope.row.id)'>
                          <span>设备配置</span>
                        </p>
                        <p v-if="delDeviceLimit" @click="delClick(scope.row.equipmentName,scope.row.id)">
                          <span>删除</span>
                        </p>
                      </div>
                      <template #reference>
                        <p class="more">
                          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear3.png">
                        </p>
                      </template>
                    </el-popover>
                  </li>
                  <li v-if="editDeviceLimit" class="editClass"
                      @click="bindGroupClick('1',scope.row.id,scope.row.idStr)">
                    <el-tooltip content="绑定峰谷、电价" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear6.svg">
                    </el-tooltip>
                  </li>
                  <!--                  <li v-if="editDeviceLimit" class="editClass"-->
                  <!--                      @click="bindWarnClick(scope.row.id)">-->
                  <!--                    <el-tooltip content="添加告警规则" effect="light" placement="top">-->
                  <!--                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear5.svg">-->
                  <!--                    </el-tooltip>-->
                  <!--                  </li>-->
                </ul>
                <ul v-if="activeName==1" class="operationUl">
                  <li v-if="editDeviceLimit" v-show="custerObj.nodeType!=2" class="editClass"
                      @click="addClick(scope.row.id)">
                    <el-tooltip content="编辑" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear1.png">
                    </el-tooltip>
                  </li>
                  <li class="editClass" @click="managementClick(scope.row.id,scope.row.idStr,scope.row.equipmentName)">
                    <el-tooltip content="数据" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear2.png">
                    </el-tooltip>
                  </li>
                  <li class="editClass" @click="goWarnFun(scope.row.id,scope.row.idStr)">
                    <el-tooltip content="报警" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear5.svg">
                    </el-tooltip>
                  </li>
                  <!--                  <li v-if="delDeviceLimit" v-show="custerObj.nodeType!=2" class="editClass"-->
                  <!--                      @click="deleteClick(scope.row.id)">-->
                  <!--                    <el-tooltip content="删除" effect="light" placement="top">-->
                  <!--                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear4.svg">-->
                  <!--                    </el-tooltip>-->
                  <!--                  </li>-->
                  <li v-if="editDeviceLimit" class="editClass"
                      @click="bindGroupClick('1',scope.row.id,scope.row.idStr)">
                    <el-tooltip content="绑定峰谷、电价" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear6.svg">
                    </el-tooltip>
                  </li>
                  <!--                  <li v-if="editDeviceLimit" class="editClass"-->
                  <!--                      @click="bindWarnClick(scope.row.id)">-->
                  <!--                    <el-tooltip content="添加告警规则" effect="light" placement="top">-->
                  <!--                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear5.svg">-->
                  <!--                    </el-tooltip>-->
                  <!--                  </li>-->

                  <!--                  <li class="editClass">-->
                  <!--                    <el-popover popper-class="moreOpera2" trigger="hover">-->
                  <!--                      <div class="listPox">-->
                  <!--                        <p @click='goWarnFun(scope.row.id,scope.row.idStr)'>报警</p>-->
                  <!--                        <p v-if="delDeviceLimit" v-show="custerObj.nodeType!=2" @click="deleteClick(scope.row.id)">-->
                  <!--                          删除</p>-->
                  <!--                      </div>-->
                  <!--                      <template #reference>-->
                  <!--                        <p class="more">-->
                  <!--                          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear3.png">-->
                  <!--                        </p>-->
                  <!--                      </template>-->
                  <!--                    </el-popover>-->
                  <!--                  </li>-->
                </ul>
              </template>
            </el-table-column>
          </el-table>
          <div class="footerBox">
            <el-pagination :disabled="disabled" :page-size="pageSize" :page-sizes="[20,100, 200, 300, 400]"
                           :total="total" background layout="total,sizes, prev, pager, next" small
                           @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
          </div>
        </div>
      </div>
    </div>

    <!--设备类型弹窗-->
    <el-dialog v-model="typeDialogVisible" :close-on-click-modal="false" :title="title" class="typeDialogVisible"
               width="544px">
      <div class="selectPox">
        <!--        <el-radio-group v-model="deviceType">-->
        <!--          <el-radio-button label="网关设备" value="网关设备"/>-->
        <!--          <el-radio-button label="直连设备" value="直连设备"/>-->
        <!--        </el-radio-group>-->
        <div :class="deviceType==='网关设备'?'activePox pox':'pox'" @click="deviceType='网关设备'">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/deviceSelect1.png">
          <p>网关设备</p>
        </div>
        <div :class="deviceType==='直连设备'?'activePox pox':'pox'" @click="deviceType='直连设备'">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/deviceSelect2.png">
          <p>直连设备</p>
        </div>
      </div>
      <template #footer>
				<span class="dialog-footer">
		    		<el-button class="resetButton" @click="typeDialogVisible = false">取消</el-button>
		    		<el-button type="primary" @click="deviceTypeFun">确认</el-button>
      			</span>
      </template>
    </el-dialog>
    <!--新增设备弹窗-->
    <el-dialog v-model="deviceDialogVisible" :close-on-click-modal="false" :title="title" :width="dialogWidth">
      <div>
        <el-form ref="deviceFormRef" :model="deviceForm" :rules="deviceRules" class="demo-ruleForm" label-width="auto"
                 style="width:98%">
          <div style="display: flex;">
            <div style="flex:1;margin-right: 30px;">
              <el-form-item label="产品类型" prop="categoryId">
                <el-select v-model="deviceForm.categoryId" clearable placeholder="请选择产品类型" style="width:100%"
                           @change="categoryChange(deviceForm.categoryId)">
                  <el-option v-for="item in allCategoryList" :key="item.id" :label="item.name" :value="item.id"
                             style="width:100%">
                  </el-option>
                </el-select>
              </el-form-item>
              <!--              <el-form-item v-if="categoryName=='电表'" label="电网费率" prop="powerGridRateId">-->
              <!--                <el-select v-model="deviceForm.powerGridRateId" clearable placeholder="请选择电网费率" style="width:100%">-->
              <!--                  <el-option v-for="item in powerGridRateData" :key="item.id" :label="item.versionNumber"-->
              <!--                             :value="item.id" style="width:100%">-->
              <!--                  </el-option>-->
              <!--                </el-select>-->
              <!--              </el-form-item>-->

              <el-form-item label="设备名称">
                <el-input v-model="deviceForm.name" placeholder="请输入设备名称"/>
              </el-form-item>
              <el-form-item label="通讯地址" prop="address">
                <el-input v-model="deviceForm.address" placeholder="请输入通讯地址" @change="addressChange"/>
              </el-form-item>
              <el-form-item label="用户类型" prop="userType">
                <el-input v-model="deviceForm.userType" placeholder="请输入用户类型"/>
              </el-form-item>
              <el-form-item label="端口" prop="port">
                <el-select v-model="deviceForm.port" clearable placeholder="请选择端口" style="width:100%">
                  <el-option v-for="item in portList" :key="item.id" :label="item.name" :value="item.id"
                             style="width:100%">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电流变比" prop="rateA">
                <el-input v-model="deviceForm.rateA" placeholder="请输入电流变比" type="number"/>
              </el-form-item>

              <el-form-item label="是否启用" prop="enableFlag">
                <el-select v-model="deviceForm.enableFlag" clearable filterable placeholder="请选择是否启用"
                           style="width:100%">
                  <el-option v-for="item in enableList" :key="item.id" :label="item.name" :value="item.id"
                             style="width:100%">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="flex:1;">
              <el-form-item label="产品型号" prop="productId">
                <el-select v-model="deviceForm.productId" clearable placeholder="请选择产品型号" style="width:100%">
                  <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"
                             style="width:100%">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="网关" prop="gatewayId">
                <el-select v-model="deviceForm.gatewayId" clearable filterable placeholder="请选择网关" style="width:100%">
                  <el-option v-for="item in gatewayList" :key="item.id" :label="item.name" :value="item.id"
                             style="width:100%">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="规约类型" prop="rulerType">
                <el-select v-model="deviceForm.rulerType" clearable placeholder="请选择规约类型" style="width:100%">
                  <el-option v-for="item in rulerTypeList" :key="item.id" :label="item.name" :value="item.id"
                             style="width:100%">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="波特率" prop="rateType">
                <el-select v-model="deviceForm.rateType" clearable placeholder="请选择波特率" style="width:100%">
                  <el-option v-for="item in rateTypeList" :key="item.id" :label="item.name" :value="item.id"
                             style="width:100%">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电压变比" prop="rateV">
                <el-input v-model="deviceForm.rateV" placeholder="请输入电压变比" type="number"/>
              </el-form-item>
              <el-form-item v-if="categoryName==='光伏'" label="总装机容量" prop="capacity" required>
                <el-input v-model="deviceForm.capacity" placeholder="请输入总装机容量"/>
              </el-form-item>
              <el-form-item v-if="deviceForm.categoryId" label="设备编码" prop="code">
                <el-input v-model="deviceForm.code" placeholder="请输入设备编码" readonly/>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="deviceForm.remark" placeholder="请输入备注"/>
              </el-form-item>
              <!--<el-form-item label="关联设备名称">
                <el-input v-model="deviceForm.relationName" placeholder="请输入关联设备名称" />
              </el-form-item>-->
            </div>
          </div>
        </el-form>
      </div>
      <template #footer>
				<span class="dialog-footer">
		    		<el-button class="resetButton" @click="deviceDialogVisible = false">取消</el-button>
		    		<el-button type="primary" @click="deviceSave">保存</el-button>
      			</span>
      </template>
    </el-dialog>
    <!--直连设备操作弹窗-->
    <!--添加弹窗-->
    <el-dialog v-model="dialogFormVisible" :close-on-click-modal="false" :title="title" class="dialogFormVisible"
               width="40%">
      <el-form ref="userForm" :inline="true" :model="formData" :rules="formRules" label-width="auto">
        <el-form-item label="名称" prop="name" style="margin-bottom: 20px">
          <el-input v-model="formData.name" placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item label="插件" prop="plugin">
          <el-select v-model="formData.plugin" clearable filterable placeholder="请选择插件" @change="selectChange">
            <el-option v-for="(item,index) in pluginData" :key="index" :label="item.name==='eKuiper'?'ZKData':item.name"
                       :value="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="formData.params" label-width="auto">
        <!--接口请求循环出来的表单数据-->
        <el-form-item v-for="(value, key, index) in formObj" :key="index" :prop="key"
                      :rules="[{
                        required: value.attribute==='required'&&(!value.condition||formData.params[value.condition.field]===value.condition.value),
                        message: `${value.type==='string'||value.type==='int'?'请输入':'请选择'}${value.name_zh}`,
                        trigger: 'blur',
                      }]" class="formItem">
          <div v-if="(!value.condition||formData.params[value.condition.field]===value.condition.value)&&value.name_zh"
               slot="label"
               class="labelBox" style="margin-top: 20px">
            <i v-if="value.attribute==='required'" style="color: red;">*</i>
            <p style="margin-left: 5px">{{ value.name_zh }}</p>
            <el-tooltip :content="value.description_zh" effect="dark" placement="top" popper-class="el_tooltip_item">
              <el-icon>
                <QuestionFilled/>
              </el-icon>
            </el-tooltip>
          </div>
          <div class="widthBox">
            <!--输入框-->
            <el-input
                v-if="value.type==='string'&&(!value.condition||formData.params[value.condition.field]===value.condition.value)"
                v-model="formData.params[key]" :maxlength="value.valid&&value.valid.length"></el-input>
            <!--下拉框-->
            <el-select
                v-if="value.type==='map'&&(!value.condition||formData.params[value.condition.field]===value.condition.value)"
                v-model="formData.params[key]" clearable>
              <el-option v-for="(item,index) in value.valid.map" :key="index" :label="item.key"
                         :value="item.value"></el-option>
            </el-select>
            <!--单选框-->
            <el-radio-group
                v-if="value.type==='bool'&&(!value.condition||formData.params[value.condition.field]===value.condition.value)"
                v-model="formData.params[key]">
              <el-radio :label="true" border>True</el-radio>
              <el-radio :label="false" border>False</el-radio>
            </el-radio-group>
            <!--数字输入框-->
            <el-input-number
                v-if="value.type==='int'&&(!value.condition||formData.params[value.condition.field]===value.condition.value)"
                v-model="formData.params[key]" :controls="false" :max="value.valid.max" :min="value.valid.min"/>
            <!--上传文件-->
            <el-upload
                v-if="value.type==='file'&&(!value.condition||formData.params[value.condition.field]===value.condition.value)"
                v-model:file-list="formData.params[key+'-fileList']" :auto-upload="false" action="#" class="upload-demo"
                limit="1" @change="uploadFile($event,key)">
              <div class="uploadBox">
                <div :class="formData.params[key+'-fileList']&&formData.params[key+'-fileList'].length>0?'none':''"
                     class="upBtnBox">
                  <el-icon>
                    <Document/>
                  </el-icon>
                  <span>点击上传</span>
                </div>
              </div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
				<span class="dialog-footer">
        <el-button class="cancle resetButton" @click="dialogFormVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="save()">保存</el-button>
      </span>
      </template>
    </el-dialog>
    <!--编辑弹窗-->
    <el-dialog v-model="editDialogFormVisible" :close-on-click-modal="false" :title="title" width="40%">
      <el-form ref="userForm2" :inline="true" :model="formData2" :rules="formRules2" label-width="auto">
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData2.name" placeholder="请输入设备名称"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
				<span class="dialog-footer">
        <el-button class="cancle resetButton" @click="editDialogFormVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="editSave()">保存</el-button>
      </span>
      </template>
    </el-dialog>
    <!--绑定弹窗-->
    <el-dialog v-model="bindDeviceDialog" title="绑定设备" width="70%">
      <el-input v-model="bDeviceName" clearable placeholder="请输入设备名称" style="width: 200px;margin:0 10px 10px 0"
                @input="getAllDeviceListFun"></el-input>
      <el-table ref="multipleTableRef2" v-loading='unBindDeviceLoading' :data="unBindDeviceList" :row-key="rowKey"
                style="width: 100%" table-layout="auto"
                @selection-change="handleSelectionChange2">
        <el-table-column :reserve-selection="true" type="selection" width="55"/>
        <el-table-column label="设备名称" prop="name"/>
        <el-table-column label="通讯地址" prop="address"/>
        <el-table-column label="产品型号" prop="productModel"/>
        <el-table-column label="创建人" prop="creatorName"/>
        <el-table-column label="创建时间" prop="createTime"/>
      </el-table>
      <el-pagination :page-size="bPageSize" :page-sizes="[20,100, 200, 300, 400]" :small="small" :total="bTotal"
                     background layout="total, prev, pager, next, sizes" small @size-change="bHandleSizeChange"
                     @current-change="bHandleCurrentChange"/>
      <template #footer>
				<span class="dialog-footer">
        <el-button class="resetButton" @click="bindDeviceDialog = false">取消</el-button>
        <el-button type="primary" @click="bindSubmit">确定</el-button>
     </span>
      </template>
    </el-dialog>
    <!--本地直连设备编辑电网费率弹窗-->
    <el-dialog v-model="editEleDialogFormVisible" :close-on-click-modal="false" :title="title" width="40%">
      <el-form ref="userForm3" :inline="true" :model="formData3" :rules="formRules3" label-width="auto">
        <el-form-item label="电网费率" prop="powerGridRateId" style="width: 100%">
          <el-select v-model="formData3.powerGridRateId" clearable placeholder="请选择电网费率" style="width:100%">
            <el-option v-for="item in powerGridRateData" :key="item.id" :label="item.versionNumber"
                       :value="item.id" style="width:100%">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
				<span class="dialog-footer">
        <el-button class="cancle resetButton" @click="editEleDialogFormVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="editEleSave()">保存</el-button>
      </span>
      </template>
    </el-dialog>
    <!--绑定组合包弹窗-->
    <el-dialog v-model="bindGroupVisible" :close-on-click-modal="false" title="绑定峰谷、电价" width="80%">
      <el-tabs v-model="tabIdx" class="demo-tabs">
        <el-tab-pane label="峰谷" name="1">
          <div class="addRateMix">
            <div style="display: flex;align-items: center;margin-bottom: 20px">
              <span style="margin-right: 10px">峰谷组合</span>
              <el-select v-model="bindGroupId" class="bagClass" clearable placeholder="请选择峰谷组合"
                         style="width: 220px;">
                <el-option v-for="(item,index) in electrovalenceBagList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="content" style="padding: 0;width: 100%;">
              <DetailModule v-if="bindGroupId" :id="bindGroupId"/>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="电价" name="2">
          <div class="addRateMix">
            <div style="display: flex;align-items: center;margin-bottom: 20px">
              <span style="margin-right: 10px">电价</span>
              <el-select v-model="bindPriceId" class="bagClass" clearable placeholder="请选择电价"
                         style="width: 220px;">
                <el-option v-for="(item,index) in elePriceList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="content" style="padding: 0;width: 100%;">
              <ElePriceDetail v-if="bindPriceId" :id="bindPriceId"/>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <template #footer>
				<span class="dialog-footer">
        <el-button class="cancle resetButton" @click="bindGroupVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="bindGroupSave()">保存</el-button>
      </span>
      </template>
    </el-dialog>
    <!--绑定告警规则弹窗-->
    <el-dialog v-model="bindWarnVisible" :close-on-click-modal="false" class="bindWarnVisible" title="添加告警规则"
               width="70%">
      <div>
        <div style="display: flex;align-items: center;margin-bottom: 20px">
          <span style="margin-right: 10px">告警规则</span>
          <el-select v-model="bindWarnId" class="bagClass" clearable placeholder="请选择告警规则"
                     style="width: 220px;">
            <el-option v-for="(item,index) in electrovalenceBagList" :key="index" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="content" style="padding: 0;width: 100%;">
          <div v-for="(item,index) in warnRuleJson" :key="index" class="rowItem">
            <el-form-item name="item.level">
              <el-select v-model="item.level" class="item" clearable disabled placeholder="请选择告警级别">
                <el-option :value="1" label="紧急告警"></el-option>
                <el-option :value="2" label="主要告警"></el-option>
                <el-option :value="3" label="次要告警"></el-option>
                <el-option :value="4" label="警告告警"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="data" name="item.dictId">
              <el-select v-model="item.dictId" class="item" disabled filterable placeholder="请选择监控指标">
                <el-option v-for="(item_d,index_d) in dataList" :key="index_d" :label="item_d.name"
                           :value="item_d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="data" name="item.value">
              <el-input v-model="item.value" class="item" disabled placeholder="请输入告警值">
                <template #prepend>
                  <el-select v-model="item.symbol" class="item" disabled placeholder="请选择">
                    <el-option label=">" value=">"></el-option>
                    <el-option label="<" value="<"></el-option>
                    <el-option label="=" value="="></el-option>
                    <el-option label=">=" value=">="></el-option>
                    <el-option label="<=" value="<="></el-option>
                  </el-select>
                </template>
              </el-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <template #footer>
				<span class="dialog-footer">
        <el-button class="cancle resetButton" @click="bindWarnVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="bindWarnSave()">保存</el-button>
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {defineProps, h, nextTick, onMounted, ref, watch} from "vue"
import {useRouter} from 'vue-router';
import {ElLoading, ElMessage, ElMessageBox} from 'element-plus'
import {Plus} from '@element-plus/icons-vue'
import {
  batchDeleteApi,
  deleteList,
  getAllCategory,
  getDetail,
  getGatewayList,
  getProductList,
  getSelectList,
  importDeviceList,
  powerGridRateList,
  saveList,
  updatePowerGridRateIdApi
} from '@/api/modules/device'
import {
  ctl,
  driversControl,
  driversList,
  getPlugin,
  getState,
  levelControl,
  nodeDelete,
  saveSouthEquipmentApi
} from "@/api/modules/southDriver";
import {downloadLogApi, getFormDataApi,} from "@/api/modules/northDriver";
import qs from 'qs';
import {
  bindDeviceListApi,
  getAllDeviceListApi,
  getDeviceIsOpenApi,
  getDeviceListLocalApi,
  removeDeviceListApi
} from "@/api/modules/project";
import DetailModule from '../../rateManagement/addRateMix/detailModule'
import ElePriceDetail from '../../rateManagement/elePrice/elePriceDetail'
import {
  bindElePricePlanListApi,
  getElePricePlanListSelectApi,
  getEquipmentWithPowerPriceListApi,
  getPowerPriceGroupListByPrefixEquipmentIdApi,
  updateGroupEquipmentApi
} from "@/api/modules/rate";
import {listSelectByPrefixEquipmentIdApi} from "@/api/modules/alarm";
import {http} from "@/api";

const props = defineProps(['custerObj', 'tabindex', 'mainType', 'mainId']);
let router = useRouter()
let route = useRouter()


// 选择网关设备或直连设备
let activeName = ref(1)
const handleTabClick = async function (tab, event) {
  pageNumber.value = 1
  pageSize.value = 20
  productModel.value = ''
  name.value = ''
  address.value = ''
  useStatus.value = ''
  await getListFun()
  if (activeName.value == 3 && custerObj.value.nodeType != 2) {
    await getPluginFun()
  }
}


// 搜索操作
let searchSelect1 = ref(activeName.value === 1 ? '1' : '2')


//设备名称的改变
const nameChange = function () {
  window.localStorage.setItem('name', name.value)
}
let pageNumber = ref(1) //页码
let pageSize = ref(20) //页数
let total = ref(0) //总页数
let tableData = ref([]) //列表数据
//重置

//每页多少
const handleSizeChange = function (val) {
  pageSize.value = val;
  getListFun();
}
//更改页数
const handleCurrentChange = function (val) {
  pageNumber.value = val;
  getListFun();
}
let loadingVal = ref(false) //表格加载
let productModel = ref() //产品线型号
let name = ref() //设备名称
let address = ref() //通讯地址
let useStatus = ref('') //状态
let getSubFlag = ref(true) //状态
//获取设备列表
let deviceList = ref([])
const getListFun = async function () {
  if (custerObj.value.id) {
    loadingVal.value = true
    let params = {
      pageNumber: pageNumber.value,
      pageSize: pageSize.value,
      id: custerObj.value.id,
      getSubFlag: getSubFlag.value ? 1 : 0,
      productModel: productModel.value,
      equipmentName: name.value,
      equipmentAddress: address.value,
      useStatus: useStatus.value,
      type: activeName.value,
      mainType: props.mainType,
      mainId: props.mainId,
    }
    if (custerObj.value.nodeType === 2) {
      await getDeviceListLocalApi(qs.stringify(params)).then(res => {
        loadingVal.value = false
        if (res.data.ok) {
          deviceList.value = res.data.result.list
          total.value = Number(res.data.result.total)
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      })
    } else {
      await getEquipmentWithPowerPriceListApi(qs.stringify(params)).then(res => {
        loadingVal.value = false
        if (res.data.ok) {
          deviceList.value = res.data.result.list
          total.value = Number(res.data.result.total)
          if (activeName.value == 3) {
            getStateFun()
          }
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      })
    }
  }
}
let allCategoryList = ref([]) //所有分类列表
//所有分类列表
const getAllCategoryFun = function () {
  getAllCategory(null).then(res => {
    if (res.data.ok) {
      allCategoryList.value = res.data.result
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
let productList = ref([]) //产品列表
//产品列表
const getProductListFun = function () {
  getProductList(qs.stringify({
    categoryId: deviceForm.value.categoryId
  })).then(res => {
    if (res.data.ok) {
      productList.value = res.data.result
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
let powerGridRateData = ref() //费率配置列表
const powerGridRateListFun = function () {
  powerGridRateList(null).then(res => {
    if (res.data.ok) {
      powerGridRateData.value = res.data.result
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
let portList = ref([])
let rateTypeList = ref([])
let rulerTypeList = ref([])
let enableList = ref([{
  id: 1,
  name: '是'
}, {
  id: 0,
  name: '否'
}])
const getSelectListFun = function () {
  getSelectList(null).then(res => {
    if (res.data.ok) {
      portList.value = res.data.result.portList
      rateTypeList.value = res.data.result.rateTypeList
      rulerTypeList.value = res.data.result.rulerTypeList
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
let gatewayList = ref([]) //网关列表
const getGatewayListFun = function () {
  getGatewayList(null).then(res => {
    if (res.data.ok) {
      gatewayList.value = res.data.result
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
let categoryName = ref()
//分类改变
const categoryChange = function (id) {
  if (deviceForm.value.categoryId) {
    getProductListFun()
  }
  allCategoryList.value.forEach(item => {
    if (item.id == id) {
      categoryName.value = item.name
      if (item.name != '电表') {
        deviceForm.value.powerGridRateId = ''
      }
    }
  })
  deviceForm.value.productId = ''
}
// 显示下级
const showNextLevel = function () {
  getListFun()
}

let dialogWidth = ref('60%') //新增设备弹窗宽度
let deviceDialogVisible = ref(false) //新增设备弹窗开关
let title = ref() //弹窗标题
let editId = ref() //编辑id
//新增设备的点击
const addClick = function (id) {
  if (id) {
    editId.value = id
    title.value = '编辑设备'
    getDetail(qs.stringify({
      id: id
    })).then(res => {
      if (res.data.ok) {
        deviceForm.value.categoryId = res.data.result.categoryId
        categoryChange(res.data.result.categoryId)
        deviceForm.value.powerGridRateId = res.data.result.powerGridRateId
        deviceForm.value.productId = res.data.result.productId
        deviceForm.value.gatewayId = res.data.result.gatewayId
        deviceForm.value.name = res.data.result.name
        deviceForm.value.address = res.data.result.address
        deviceForm.value.enableFlag = res.data.result.enableFlag
        deviceForm.value.rulerType = String(res.data.result.rulerType)
        deviceForm.value.userType = res.data.result.userType
        deviceForm.value.rateType = String(res.data.result.rateType)
        deviceForm.value.port = String(res.data.result.port)
        deviceForm.value.rateV = res.data.result.rateV
        deviceForm.value.code = res.data.result.code
        deviceForm.value.capacity = res.data.result.capacity
        deviceForm.value.rateA = res.data.result.rateA
        deviceForm.value.remark = res.data.result.remark
        deviceForm.value.relationName = res.data.result.relationName
        deviceForm.value.projectId = custerObj.value.id
        getProductListFun()
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
    deviceDialogVisible.value = true
  } else {
    typeDialogVisible.value = true
    title.value = '设备类型'
  }
}
const deviceTypeFun = function () {
  if (deviceType.value == '网关设备') {
    editId.value = ''
    deviceForm.value = {
      categoryId: '',
      powerGridRateId: '',
      productId: '',
      gatewayId: '',
      name: '',
      address: '',
      enableFlag: 1,
      rulerType: '',
      userType: '1',
      rateType: '',
      port: '',
      rateV: 1,
      rateA: 1,
      capacity: '',
      remark: '',
      relationName: ''
    }
    deviceDialogVisible.value = true
    typeDialogVisible.value = false
  } else {
    // 判断是直连设备
    formData.value = {
      name: '',
      plugin: '',
      params: {}
    }
    dialogFormVisible.value = true
    typeDialogVisible.value = false


    // router.push({
    //   path: '/admin/southDriver',
    //   query: {
    //     ty: 1
    //   }
    // })
  }
}
let deviceFormRef = ref() //设备
//设备表单
let deviceForm = ref({
  categoryId: '',
  powerGridRateId: '',
  productId: '',
  gatewayId: '',
  name: '',
  address: '',
  enableFlag: 1,
  rulerType: '',
  userType: '1',
  rateType: '',
  port: '',
  rateV: 1,
  rateA: 1,
  capacity: '',
  remark: '',
  relationName: ''
})
// 设备表单验证规则
let deviceRules = ref({
  categoryId: [{
    required: true,
    message: '请选择产品类型',
    trigger: 'blur'
  }],
  productId: [{
    required: true,
    message: '请选择产品型号',
    trigger: 'blur'
  }],
  gatewayId: [{
    required: true,
    message: '请选择网关',
    trigger: 'blur'
  }],
  name: [{
    required: true,
    message: '请输入设备名称',
    trigger: 'blur'
  }],
  address: [{
    required: true,
    message: '请输入通讯地址',
    trigger: 'blur'
  }],
  port: [{
    required: true,
    message: '请选择端口',
    trigger: 'blur'
  }],
  rateV: [{
    required: true,
    message: '请输入电压变比',
    trigger: 'blur'
  }],
  rateA: [{
    required: true,
    message: '请输入电流变比',
    trigger: 'blur'
  }],
  capacity: [{
    required: true,
    message: '请输入总装机容量',
    trigger: 'blur'
  }],

})
//设备的保存
const deviceSave = function () {
  let params = {
    productId: deviceForm.value.productId,
    gatewayId: deviceForm.value.gatewayId,
    powerGridRateId: categoryName.value == '电表' ? deviceForm.value.powerGridRateId : null,
    name: deviceForm.value.name,
    address: deviceForm.value.address,
    enableFlag: deviceForm.value.enableFlag,
    rulerType: deviceForm.value.rulerType,
    userType: deviceForm.value.userType,
    rateType: deviceForm.value.rateType,
    port: deviceForm.value.port,
    rateV: deviceForm.value.rateV,
    rateA: deviceForm.value.rateA,
    capacity: deviceForm.value.capacity,
    remark: deviceForm.value.remark,
    relationName: deviceForm.value.relationName,
    type: 1,
    projectId: custerObj.value.id
  }
  if (title.value == '新建设备') {
    params['id'] = 0
  } else if (title.value == '编辑设备') {
    params['id'] = editId.value
  }
  if (deviceFormRef) {
    deviceFormRef.value.validate((valid) => {
      //提交成功
      if (valid) {
        if (deviceForm.value.name) {
          saveList(
              qs.stringify(params)
          ).then(async res => {
            if (res.data.ok) {
              deviceDialogVisible.value = false
              getListFun()
            } else {
              ElMessage({
                message: res.data.message,
                type: 'error'
              })
            }
          }).catch(err => {
            console.log(err);
          })
        } else {
          ElMessage({
            message: '请输入设备名称',
            type: 'info'
          })
        }
      }
    })
  }
}
//删除
const deleteClick = function (id) {
  ElMessageBox.confirm("确认删除吗，删除后不可恢复，请谨慎操作", '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除设备',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {
        style: 'color:#595959;'
      }, '请确认是否要删除此设备，删除后数据不可恢复'),
    ])
  }).then(() => {
    deleteList(
        qs.stringify({
          id: id
        })
    ).then(res => {
      if (res.data.ok) {
        getListFun()
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      message: '已取消删除',
      type: 'info',
    })
  });
}
//通讯地址改变
const addressChange = function () {
  deviceForm.value.address = deviceForm.value.address.padStart(12, '0')
}
//管理
const managementClick = function (id, idStr, equipmentName) {
  // router.push({
  //   path: '/admin/projectData',
  //   query: {
  //     isLocal: custerObj.value.nodeType,
  //     id: id,
  //     type: activeName.value
  //   }
  // })
  window.open(`#/admin/projectData?isLocal=${custerObj.value.nodeType}&id=${id}&idStr=${idStr}&type=${activeName.value}&equipmentName=${encodeURIComponent(equipmentName)}&projectName=${custerObj.value.name}`, '_blank');
}
// 点击报警
const goWarnFun = function (id, idStr) {
  // router.push({
  //   path: '/admin/projectWarning',
  //   query: {
  //     id: id
  //   }
  // })
  window.open(`#/admin/projectWarning?id=${idStr}`, '_blank');
}


/*直连设备****************************************************************************/
// 新建直连设备弹窗
let dialogFormVisible = ref(false)
//获取插件列表
let pluginData = ref([])
const getPluginFun = function () {
  getPlugin(null).then(res => {
    if (res.status == 200) {
      pluginData.value = res.data.plugins
      deviceList.value.forEach(item => {
        pluginData.value.forEach(items => {
          if (item.productModel == items.name) {
            item.plugin2 = items.schema
          }
        })
      })
    } else {
      pluginData.value = []
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}

// 添加设备表单数据----------------------------------------------
let formData = ref({
  name: '',
  plugin: '',
  params: {}
})
// 添加设备表单验证
let formRules = ref({
  name: [{
    required: true,
    message: '请输入设备名称',
    trigger: 'change',
  }],
  plugin: [{
    required: true,
    message: '请选择插件',
    trigger: 'blur'
  }],
  copyName: [{
    required: true,
    message: '请输入驱动名称',
    trigger: 'change',
  }],
})
let userForm = ref() // 提交添加设备表单
// 添加设备的保存
const save = function () {
  userForm.value.validate((valid) => {
    //提交成功
    if (valid) {
      saveSouthEquipmentApi(qs.stringify({
        id: 0,
        name: formData.value.name,
        plugin: formData.value.plugin,
        projectId: custerObj.value.id,
        params: JSON.stringify(formData.value.params),
        authorization: 'Bearer ' + window.localStorage.getItem('token')
      })).then(res => {
        if (res.data.code === 0) {
          dialogFormVisible.value = false
          typeDialogVisible.value = false
          getListFun()
        } else {
          ElMessage({
            type: 'error',
            message: res.data.message
          });
        }
      }).catch(err => {
        console.log(err)
      })
    }
  })
}
// 直连设备的列表详情
//获取设备列表
const getStateFun = function () {
  getState(null).then(res => {
    if (res.status == 200) {
      deviceList.value.forEach(item => {
        res.data.states.forEach(items => {
          if (item.equipmentName == items.node) {
            item.link = items.link
            item.running = items.running
            item.rtt = items.rtt
            if (items.running == 3) {
              item.switch = true
            } else {
              item.switch = false
            }
            item.log_level = items.log_level
          }
        })
      })
      console.log(deviceList.value)
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 插件选择事件
let formObj = ref({})
const selectChange = function () {
  var schema_name;
  pluginData.value.forEach(items => {
    if (formData.value.plugin == items.name) {
      schema_name = items.schema
    }
  })
  getFormDataApi({
    schema_name: schema_name
  }).then(res => {
    if (res.status === 200) {
      formData.value = {
        name: formData.value.name,
        plugin: formData.value.plugin,
        params: {}
      }
      formObj.value = res.data
      let num = 0
      for (const key in formObj.value) {
        formData.value.params[key] = formObj.value[key].default
        if (formObj.value[key].type === 'file') {
          let fileList = key + '-fileList'
          formData.value.params[fileList] = []
          num++
        }
      }
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 本地直连设备电网费率更新-----------------------
let editEleDialogFormVisible = ref(false)
let formData3 = ref({
  id: 0,
  powerGridRateId: '',
})
let formRules3 = ref({
  powerGridRateId: [{
    required: true,
    message: '请选择电网费率',
    trigger: 'change',
  }],
})
const eleSetClick = function (row) {
  formData3.value.id = row.id
  formData3.value.powerGridRateId = row.powerGridRateId
  editEleDialogFormVisible.value = true
}
let userForm3 = ref() // 提交编辑设备表单
//编辑的保存
const editEleSave = function () {
  userForm3.value.validate((valid) => {
    //提交成功
    if (valid) {
      updatePowerGridRateIdApi(qs.stringify(formData3.value)).then(res => {
        if (res.data.code == 0) {
          getListFun()
          editEleDialogFormVisible.value = false
        } else {
          ElMessage({
            type: 'error',
            message: res.data.message
          });
        }
      }).catch(err => {
        console.log(err)
      })
    }
  })
}


// 设备连接断开----------------------------------------------
// 应用连接断开
let loading = ref(false)
const isOpenChange = function (value, scope) {
  ctl({
    cmd: scope.running === 3 ? 1 : 0,
    node: scope.equipmentName,
  }).then(res => {
    loading.value = false
    if (res.status === 200) {
      getListFun()
      ElMessage({
        message: scope.running === 3 ? '停止成功' : '运行成功',
        type: 'success'
      })
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    loading.value = false
    console.log(err);
  })
}

//关闭或开启debug日志----------------------------------------------
const debugClick = function (log_level, name) {
  var level;
  if (log_level == 'debug') {
    level = 'notice'
  } else {
    level = 'debug'
  }
  var params = {
    core: false,
    level: level,
    node: name
  }
  levelControl(params).then(res => {
    if (res.status == 200) {
      getListFun()
      copyeditDialogFormVisible.value = false
      if (log_level == 'debug') {
        ElMessage({
          message: '已关闭DEBUG日志！',
          type: 'success'
        })
      } else if (log_level == 'notice') {
        ElMessage({
          message: '已开启DEBUG日志！',
          type: 'success'
        })
      }
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
//组的点击
const groupClick = function (node) {
  router.push({
    path: '/admin/group',
    query: {
      node: node
    }
  })
}
let typeDialogVisible = ref(false)
let deviceType = ref("网关设备")
let editDialogFormVisible = ref(false) // 编辑表单弹窗
let oldName = ref()
// 编辑设备点击----------------------------------------------
const editClick = function (row) {
  editDialogFormVisible.value = true
  title.value = "编辑设备"
  formData2.value = {
    id: row.id,
    name: row.equipmentName,
    authorization: 'Bearer ' + window.localStorage.getItem('token')
  }
  oldName = row.name
}
// 编辑设备表单数据
let formData2 = ref({
  id: 0,
  name: '',
  authorization: 'Bearer ' + window.localStorage.getItem('token')
})
// 编辑设备表单验证
let formRules2 = ref({
  name: [{
    required: true,
    message: '请输入设备名称',
    trigger: 'change',
  }],
})
let userForm2 = ref() // 提交编辑设备表单
//编辑的保存
const editSave = function () {
  var params = {
    name: oldName,
    new_name: formData2.value.name
  }
  userForm2.value.validate((valid) => {
    //提交成功
    if (valid) {
      saveSouthEquipmentApi(qs.stringify(formData2.value)).then(res => {
        if (res.data.code == 0) {
          getListFun()
          editDialogFormVisible.value = false
        } else {
          ElMessage({
            type: 'error',
            message: res.data.message
          });
        }
      }).catch(err => {
        console.log(err)
      })
    }
  })
}
//数据统计/数据配置----------------------------------------------
const deviceDetailClick = function (type, node, plugin, id) {
  router.push({
    path: '/admin/deviceDetail',
    query: {
      type: type,
      node: node,
      plugin: plugin,
      id: id,
      projectId: custerObj.value.id
    }
  })
}
let driversData = ref([])
// let formData = ref({})
//复制弹窗的点击----------------------------------------------
let copyeditDialogFormVisible = ref(false)
const copyClick = function (name) {
  formData.value.copyName = name + '_copy'
  copyeditDialogFormVisible.value = true
  driversList({
    name: name
  }).then(res => {
    if (res.status == 200) {
      driversData.value = res.data
      driversData.value.nodes[0].name = formData.value.copyName
    } else {
      driversData.value = []
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
//复制弹窗的保存
const copySave = function () {
  driversControl(driversData.value).then(res => {
    if (res.status == 200) {
      getListFun()
      copyeditDialogFormVisible.value = false
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 下载驱动日志
const downloadLogFun = function (scope) {
  const downloadZip = (data, fileName = '驱动日志') => {
    var blob = new Blob([data], {
      type: 'application/x-tar'
    })
    if ('download' in document.createElement('a')) {
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) //创建下载的链接
      downloadElement.href = href
      downloadElement.download = fileName //下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() //点击下载
      document.body.removeChild(downloadElement) //下载完成移除元素
      window.URL.revokeObjectURL(href) //释放掉blob对象
    }
  }
  openFullScreen()
  downloadLogApi(scope.equipmentName).then(res => {
    loadingAdd.value.close()
    if (res.status === 200) {
      downloadZip(res.data)
      ElMessage({
        type: 'success',
        message: '下载成功',
      })
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 删除设备
const delClick = function (name, id) {
  ElMessageBox.confirm('', '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除组',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {
        style: 'color:#595959;'
      }, '请确认是否要删除此组，删除后数据不可恢复'),
    ])
  }).then(() => {
    deleteList(
        qs.stringify({
          id: id
        })
    ).then(res => {
      if (res.data.ok) {
        getListFun()
        nodeDelete({
          name: name
        }).then(res => {
          if (res.status == 200) {
            ElMessage({
              type: 'success',
              message: '删除成功',
            })
            getListFun()
          } else {
            ElMessage({
              type: 'error',
              message: res.data.message,
            })
          }
        }).catch(err => {
          console.log(err);
        })
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '取消删除',
    })
  })
}


// 绑定事件----------------------------------------------------------------------------
let bindFlag = ref(true)
let bTotal = ref()
let bPageNumber = ref(1)
let bPageSize = ref(20)
let bDeviceName = ref()
let unBindDeviceLoading = ref(false)
// 绑定弹窗
let bindDeviceDialog = ref(false)
// 未绑定的设备列表
let unBindDeviceList = ref([])
// 获取未绑定设备列表
const getAllDeviceListFun = async function () {
  await getAllDeviceListApi(qs.stringify({
    pageNumber: bPageNumber.value,
    pageSize: bPageSize.value,
    name: bDeviceName.value,
    type: 1
  })).then(res => {
    unBindDeviceLoading.value = false
    if (res.data.code === 0) {
      unBindDeviceList.value = res.data.result.list
      bTotal.value = Number(res.data.result.total)
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 点击绑定
const bindClick = async function () {
  bindDeviceDialog.value = true
  unBindDeviceLoading.value = true
  await getAllDeviceListFun()
  multipleTableRef2.value.clearSelection()
}
const bHandleSizeChange = function (e) {
  bPageSize.value = e
  getAllDeviceListFun()
}
const bHandleCurrentChange = function (e) {
  bPageNumber.value = e
  getAllDeviceListFun()
}
// 设备表格多选事件
let checkIdArr2 = ref([])
const handleSelectionChange2 = function (e) {
  checkIdArr2.value = []
  for (let i = 0; i < e.length; i++) {
    checkIdArr2.value.push(Number(e[i].id))
  }
  checkIdArr2.value = [...new Set(checkIdArr2.value)]
}
// 全选
let multipleTableRef2 = ref()
const checkAll2 = async function (e) {
  let arr = []
  await getAllDeviceListApi(qs.stringify({
    pageNumber: 1,
    pageSize: bTotal.value,
    name: bDeviceName.value,
    type: 1
  })).then(res => {
    if (res.data.code === 0) {
      arr = res.data.result.list
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })

  // 判断全选或全不选
  if (!multipleTableRef2.value.store.states.isAllSelected.value) {
    multipleTableRef2.value.clearSelection()
  } else {
    for (let i = 0; i < arr.length; i++) {
      multipleTableRef2.value.toggleRowSelection(arr[i], true)
    }
  }
}
const rowKey = function (row) {
  return row.id
}
const rowKey2 = function (row) {
  return row.id
}

// 提交绑定
const bindSubmit = function () {
  bindDeviceListApi(qs.stringify({
    type: 1,
    id: custerObj.value.id,
    idList: checkIdArr2.value.join(',')
  })).then(res => {
    if (res.data.code === 0) {
      bindDeviceDialog.value = false
      getListFun()
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}

// 解绑事件----------------------------------------------------------------------------
// 点击解绑
const removeClick = function (id) {
  ElMessageBox.confirm('请确认是否要解绑这些设备', 'Warning', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
    title: ''
  }).then(() => {
    removeDeviceListApi(qs.stringify({
      idList: id ? id : checkIdArr.value.join(','),
      id: custerObj.value.id,
      type: activeName.value
    })).then(res => {
      if (res.data.code === 0) {
        ElMessage({
          type: 'success',
          message: '解绑成功',
        })
        getListFun()
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message,
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '取消解绑',
    })
  })
}
// 点击删除
const batchDelClick = function (id) {
  ElMessageBox.confirm('请确认是否要删除这些设备', 'Warning', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
    title: ''
  }).then(() => {
    batchDeleteApi(qs.stringify({
      idList: checkIdArr.value.join(',')
    })).then(res => {
      if (res.data.code === 0) {
        ElMessage({
          type: 'success',
          message: '删除成功',
        })
        getListFun()
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message,
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '取消删除',
    })
  })
}
// 表格多选框选择事件
let checkIdArr = ref([])
let checkIdArrStr = ref([])
const handleSelectionChange = function (e) {
  checkIdArr.value = []
  for (let i = 0; i < e.length; i++) {
    checkIdArr.value.push(Number(e[i].id))
  }
  checkIdArr.value = [...new Set(checkIdArr.value)]
  checkIdArrStr.value = []
  for (let i = 0; i < e.length; i++) {
    checkIdArrStr.value.push(e[i].idStr)
  }
  checkIdArrStr.value = [...new Set(checkIdArrStr.value)]
}
// 全选
let multipleTableRef = ref()
const checkAll = async function (e) {
  let arr = []
  let params = {
    pageNumber: 1,
    pageSize: total.value,
    id: custerObj.value.id,
    getSubFlag: getSubFlag.value ? 1 : 0,
    productModel: productModel.value,
    equipmentName: equipmentName.value,
    equipmentAddress: equipmentAddress.value,
    mainType: props.mainType,
    mainId: props.mainId,
  }
  await getEquipmentWithPowerPriceListApi(qs.stringify(params)).then(res => {
    if (res.data.ok) {
      arr = res.data.result.list

    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })

  // 判断全选或全不选
  if (!multipleTableRef.value.store.states.isAllSelected.value) {
    multipleTableRef.value.clearSelection()
  } else {
    for (let i = 0; i < arr.length; i++) {
      multipleTableRef.value.toggleRowSelection(arr[i], true)
    }
  }
}


// 导入设备---------------------------------------------------------------
let personData = ref({}) //自定义上传参数
let fileList = ref([]) //上传文件
const importClick = function () {
  document.getElementById("fileName").click();
}
const uploadFile2 = function (file) {
  let fd = new FormData();
  fd.append('file', file.raw);
  importDeviceList(fd).then(res => {
    if (res && res.data && res.data.ok) {
      //console.log(res)
      getListFun()
      ElMessage({
        type: 'success',
        message: '导入成功！'
      });
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}

// 加载的动画
let loadingAdd = ref()
const openFullScreen = function () {
  loadingAdd.value = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.1)'
  })
}
// 导出设备---------------------------------------------------------------
const exportClick = function () {
  openFullScreen()
  window.location.href = http + 'zouk/rest/project/exportEquipment?id=' + custerObj.value.id + '&getSubFlag=' + (getSubFlag.value ? 1 : 0) + '&productModel=' + productModel.value + '&equipmentName=' + name.value + '&equipmentAddress=' + address.value + '&useStatus=' + useStatus.value + '&type=' + activeName.value + '&memberId=' + window.localStorage.getItem('memberId')
  setTimeout(() => {
    loadingAdd.value.close();
    dialogVisible2.value = false
    ElMessage({
      type: 'success',
      message: '导出成功'
    });
  }, 1000);
  loadingAdd.value.close()
}


// 进入全屏
const enterFullScreen = () => {
  // 获取layout的dom元素
  const parentNode = document.querySelector('.rightBox'); // 获取需要全屏的元素;
  // document.querySelector('.largeScreenContent .chart').style.height = 'calc(100% - 140px)'  //进入全屏后变大图片
  // 进入全屏
  if (parentNode.requestFullscreen) {
    parentNode.requestFullscreen();
  } else if (parentNode.webkitRequestFullScreen) {
    parentNode.webkitRequestFullScreen();
  } else if (parentNode.mozRequestFullScreen) {
    parentNode.mozRequestFullScreen();
  } else if (parentNode.msRequestFullscreen) {
    // IE11
    parentNode.msRequestFullscreen();
  }


};
// 退出全屏
const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if ((document).webkitCancelFullScreen) {
    (document).webkitCancelFullScreen();
  } else if ((document).mozCancelFullScreen) {
    (document).mozCancelFullScreen();
  } else if ((document).msExitFullscreen) {
    (document).msExitFullscreen();
  }

};


// 绑定组合包---------------------------------------------------------------
let tabIdx = ref('1')
let bindGroupVisible = ref(false)  //绑定组合包弹窗
let bindGroupId = ref() // 组合包id
let bindPriceId = ref() // 电价id
let bindGroupEquipmentId = ref() // 绑定组合包的设备id
let bindGroupEquipmentIdStr = ref() // 绑定组合包的设备id
let electrovalenceBagList = ref([])
let elePriceList = ref([])
// 点击绑定组合包
const bindGroupClick = function (type, id, idStr) {
  tabIdx.value = type
  bindGroupEquipmentId.value = id ? id : null
  bindGroupEquipmentIdStr.value = idStr ? idStr : null
  bindGroupVisible.value = true
  // 获取峰谷组合列表
  getPowerPriceGroupListByPrefixEquipmentIdApi(qs.stringify({
    prefixId: idStr ? idStr : null,
  })).then(res => {
    if (res.data.code === 0) {
      electrovalenceBagList.value = res.data.result
      let flag = true
      for (let i = 0; i < electrovalenceBagList.value.length; i++) {
        if (electrovalenceBagList.value[i].checkFlag) {
          bindGroupId.value = electrovalenceBagList.value[i].id
          flag = false
        }
      }
      if (flag) {
        bindGroupId.value = ''
      }
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
  // 获取电价列表
  getElePricePlanListSelectApi(qs.stringify({
    equipmentId: idStr ? idStr : null,
  })).then(res => {
    if (res.data.code === 0) {
      elePriceList.value = res.data.result
      let flag = true
      for (let i = 0; i < elePriceList.value.length; i++) {
        if (elePriceList.value[i].checkFlag) {
          bindPriceId.value = elePriceList.value[i].id
          flag = false
        }
      }
      if (flag) {
        bindPriceId.value = ''
      }
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 绑定组合包提交
const bindGroupSave = function () {
  if (!bindGroupId.value) {
    ElMessage({
      message: '请选择峰谷包',
      type: 'info'
    })
  } else {
    updateGroupEquipmentApi(qs.stringify({
      id: bindGroupId.value,
      equipmentType: activeName.value,
      equipmentIdList: bindGroupEquipmentId.value ? bindGroupEquipmentId.value : checkIdArr.value.join(',')
    })).then(res => {
      if (res.data.code === 0) {
        bindGroupVisible.value = false
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }

  bindElePricePlanListApi(qs.stringify({
    id: bindPriceId.value,
    equipmentType: activeName.value,
    // equipmentId: bindGroupEquipmentId.value ? bindGroupEquipmentId.value : checkIdArr.value.join(',')
    equipmentIdList: bindGroupEquipmentIdStr.value ? bindGroupEquipmentIdStr.value : checkIdArrStr.value.join(',')
  })).then(res => {
    if (res.data.code === 0) {
      bindGroupVisible.value = false
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 绑定告警规则---------------------------------------------------------------
// 指标列表
let dataList = ref([])
// 获取指标列表
const getDataListFun = function () {
  listSelectByPrefixEquipmentIdApi(qs.stringify({
    equipmentIdList: formData.value.equipmentIdList1.join(',')
  })).then(res => {
    if (res.data.code === 0) {
      dataList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
let bindWarnVisible = ref(false)  //绑定组合包弹窗
let bindWarnId = ref() // 组合包id
let warnRuleJson = ref([{
  level: '',
  dictId: '',
  symbol: '',
  value: '',
}])
// 点击绑定组合包
const bindWarnClick = function () {
  bindWarnVisible.value = true
}
// 绑定告警提交
const bindWarnSave = function () {
  // checkIdArr.value.join(',')
}


// 设备操作权限
let addDeviceLimit = ref(false)
let editDeviceLimit = ref(false)
let delDeviceLimit = ref(false)
let isOpenDevice = ref(1)
/*生命周期*/
onMounted(async () => {
  getAllCategoryFun()
  getSelectListFun()
  getGatewayListFun()
  // powerGridRateListFun()
  if (activeName.value == 3 && custerObj.value.nodeType != 2) {
    await getPluginFun()
  }

  activeName.value = 1
  if (router.currentRoute.value.query.type == 3) {
    activeName.value = 3
  }
  // const query = {...route.query};
  // // 使用新的查询参数替换当前路由
  // router.replace({query});

  getDeviceIsOpenApi().then(res => {
    if (res.data.ok) {
      isOpenDevice.value = res.data.result
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })


  // 获取设备的操作权限
  let arr = JSON.parse(window.window.localStorage.getItem('menuList'))
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].menuKey === '/admin/project') {
      for (let j = 0; j < arr[i].subList.length; j++) {
        if (arr[i].subList[j].menuKey === 'addDevice') {
          addDeviceLimit.value = true
        } else if (arr[i].subList[j].menuKey === 'editDevice') {
          editDeviceLimit.value = true
        } else if (arr[i].subList[j].menuKey === 'delDevice') {
          delDeviceLimit.value = true
        }
      }
    }
  }
})

let custerObj = ref()
// 监听props.data.list中每个元素的变化，当它变化时，启动动画
watch(() => props.custerObj, async (newValues, oldValues) => {
  console.log(newValues)
  custerObj.value = newValues
  if (newValues.id) {
    if (isOpenDevice.value == 0 && custerObj.value.nodeType != 2) {
      activeName.value = 1
    }
    activeName.value = props.tabindex == 7 ? 3 : 1
    await getListFun()
    if (activeName.value == 3 && custerObj.value.nodeType != 2) {
      await getPluginFun()
    }
  }
}, {immediate: true, deep: true});


watch(() => props.tabindex, async (newValues, oldValues) => {
  if (newValues == 6) {
    nextTick(() => {
      activeName.value = 1
      searchSelect1.value = '1'
    })
  } else if (newValues == 7) {
    nextTick(() => {
      activeName.value = 3
      searchSelect1.value = '2'
    })

  }
  await getListFun()
  handleTabClick()
}, {immediate: true, deep: true});

</script>

<style lang="less">
.projectDeviceCopy {
  background: #fff;
  width: calc(100% - 32px);
  height: calc(100% - 25px);
  padding: 0 16px 24px;
  overflow: auto;
  border-top: 0;
  //标题
  > .title {
    width: 100%;
    height: 0;
    padding: 0;

    .el-tabs {
      padding-top: 8px;

      .el-tabs__nav-scroll {
        padding-left: 24px;
      }
    }
  }

  //内容
  .projectDeviceContent {
    width: 100%;
    height: calc(100% - 36px);
    padding: 0;
    margin: 0;
    display: block;
    //搜索
    .searchBox {
      position: relative;
      width: 100%;
      margin-bottom: 16px;
      display: flex;

      .el-form {
        width: 100%;
        display: flex;

        .searchPox {
          //width: calc(100% - 135px);
          //display: flex;
          //flex-direction: column;

          .liBox:first-child {
            .el-form-item {
            }
          }

          .liBox {
            width: 128px;
            display: inline-block;
            margin-right: 8px;

            .el-form-item {
              display: flex;
              margin-bottom: 0;

              .el-select, .el-input, .el-input__wrapper {
                width: 128px;
              }

              .el-radio {
                margin-right: 10px;
              }
            }
          }
        }

        .searchBtn {
          width: calc(100% - 20px) !important;
          margin-bottom: 0 !important;

          .el-button {
            margin-left: 0;
            margin-right: 12px;
            margin-bottom: 10px;
          }

          .el-checkbox__input {
            .el-checkbox__inner {
              background-color: #165DFF;
            }
          }

          .el-checkbox__input.is-focus {
            .el-checkbox__inner {
              background-color: #fff;
            }

            .el-checkbox__inner:after {
              border-color: #165DFF;
            }
          }
        }
      }

    }


    /*卡片*/

    .cardBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .cardContent {
        position: relative;
        margin: 16px 0 0 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border: 1px solid #E5E6EB;
        width: 24%;
        min-width: 268px;
        height: 246px;
        border-radius: 6px;
        background: #FFFFFF;
        overflow: hidden;

        .titleBox {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: calc(100% - 44px);
          cursor: pointer;
        }

        .topBox {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          height: 44px;

          .leftBox {
            display: flex;
            flex-direction: column;
            padding-left: 16px;
            justify-content: space-between;

            div:nth-child(1) {
              color: #1D2129;
              font-size: 15px;
              font-weight: bold;
            }

            div:nth-child(2) {
              color: rgba(0, 0, 0, .4);
              font-size: 12px;
            }
          }

          .rightBox {
            margin-right: 16px;
            text-align: right;
          }
        }

        .centerBox {
          height: 41px;
          display: flex;
          justify-content: space-between;
          padding: 0 16px;

          .leftBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            div:nth-child(1) {
              color: #86909C;
              font-size: 12px;
            }

            div:nth-child(2) {
              color: #1D2129;
              font-size: 14px;
            }
          }

          .rigthBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            text-align: right;

            div:nth-child(1) {
              color: #86909C;
              font-size: 12px;
            }

            div:nth-child(2) {
              color: #1D2129;
              font-size: 14px;
            }

            width: 36%;
          }
        }

        .bottomBox {
          height: 41px;
          background-color: #F8F9FB;
          overflow: hidden;
          display: flex;
          align-items: center;

          div {
            flex: 1;
            text-align: center;
            color: #165DFF;
            font-size: 14px;
            cursor: pointer;
          }

          div:nth-child(2) {
            border-left: 1px solid rgba(0, 0, 0, .06);
            border-right: 1px solid rgba(0, 0, 0, .06);
          }

          div:last-child {
            color: #EF2121;
          }
        }
      }

      .cardContent:hover {
        box-shadow: 7px 7px 32px 0px rgba(158, 176, 207, 0.48);
      }
    }

    .cardBox.cardBox2 {
      .cardContent {
        height: 200px;
      }

      .centerBox {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: calc(100% - 58px);
        padding: 16px;

        .leftBox {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
        }
      }
    }

    .statusOnClass {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 60px;
      height: 22px;
      background: #E8FFEA;
      border-radius: 3px;
      color: #00B42A;

      .dotOnClass {
        border-radius: 50%;
        width: 6px;
        height: 6px;
        background: #00B42A;
      }
    }

    .statusOutClass {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 60px;
      height: 22px;
      background: #FFECE8;
      border-radius: 3px;
      color: #F53F3F;

      .dotOutClass {
        border-radius: 50%;
        width: 6px;
        height: 6px;
        background: #F53F3F;
      }
    }

    /*element表格*/


    .tableBox {
      width: 100%;
      height: 100%;
      padding: 0 !important;
      box-shadow: 0 0 0 0 !important;

      .operationBox {
        background-color: #fff;
        display: flex;
        justify-content: space-between;

        .tabBox {
          display: flex;
          justify-content: center;
          padding: 0 4px;
          align-items: center;
          width: 138px;
          background-color: #F2F3F5;
          border-radius: 2px;

          div {
            flex: 1;
            border-radius: 2px;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            background-color: #F2F3F5;
            color: #919193;
          }

          div:nth-child(1) {
            margin-right: 4px;
          }

          .active {
            background-color: #fff;
            color: #165DFF;
          }
        }
      }

      .operationUl {
        padding: 0;
        margin: 0;
        display: flex;
        //justify-content: space-between;
        align-items: center;

        .groupClass {
          width: 20px;
          height: 20px;
        }

        li {
          cursor: pointer;
          margin-right: 10px;
          margin-left: 0 !important;
          display: flex;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
          }

          .is-checked {
            .el-switch__core {
              border: 1px solid #00b173;;
            }

            .el-switch__action {
              background-color: #00b173;
            }
          }

          .more {
            font-size: 20px;
            font-weight: bold;
          }
        }

        li:last-child {
          margin-right: 0;
        }
      }

      .editClass {
        cursor: pointer;
        color: #165DFF;
        //margin: 0 !important;
      }

      .deleteClass {
        cursor: pointer;
        color: #EF2121;
      }

      .el-table thead th {
        background: rgb(250, 250, 250);
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
      }

      .el-table__body-header .el-table__cell {
        padding: 0;
      }

      .userClass {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-right: 4px;
      }

      .adressClass {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-left: 4px;
      }
    }

    //分页
    .footerBox {
      margin: 14px 0 24px 0;
      display: flex;
      justify-content: flex-end;
    }
  }

  .el-form-item__label {
    font-size: 15px;
  }

  .el-input__validateIcon {
    display: none;
  }

  .el-input__suffix {
    color: #000;
  }

  //配置实时数据弹窗
  .parserClass {
    display: inline-block;
    width: 140px;
    height: 30px;
    line-height: 26px;
    padding: 4px 0 8px 4px;
    margin: 0 3px 6px 4px;
    border: 1px solid #439DFD;
    border-radius: 4px;
    vertical-align: top;

    .nameClass {
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      text-align: center;
    }
  }

  .checkAllBox {
    margin-left: 2px;
    margin-bottom: 16px;
  }

  .nameClass2 {
    margin-left: 24px;
    font-size: 12px;
    height: 0px;
    line-height: 0px;
  }

  .nameClass3 {
    color: #439DFD;
    margin-left: 24px;
    font-size: 12px;
    height: 0px;
    line-height: 0px;
  }

  .parserClass2 {
    display: inline-block;
    width: 210px;
    height: 30px;
    line-height: 26px;
    padding: 0 0 12px 4px;
    margin: 0 10px 6px 4px;
    border: 1px solid #439DFD;
    border-radius: 4px;
  }

  .parserClass3 {
    display: inline-block;
    width: 210px;
    height: 30px;
    line-height: 26px;
    padding: 0 0 12px 4px;
    margin: 0 10px 6px 4px;
    border: 1px solid #6A6A6A;
    border-radius: 4px;
  }

  .nowdataClass {
    margin-bottom: 10px;
    margin-left: 4px;
  }

  .el-radio-button__original-radio:checked + .el-radio-button__inner {
    background-color: #165DFF;
    border: 1px solid #165DFF;
  }


  //弹窗
  .dialogFormVisible {
    //min-width: 1000px;
    .el-dialog__header {
      border-bottom: 1px solid #efefef;
      margin: 0;
    }

    .el-dialog__footer {
      border-top: 1px solid #efefef;
      margin: 0;
    }

    .el-form-item {
      display: block;
      margin-bottom: 0;
      margin-right: 0;

      .el-select,
      .el-input-number {
        width: 100%;

        .el-input__inner {
          text-align: left;
        }
      }

      .el-form-item__content {
        display: block;

        .operation {
          margin: 5px 0 10px;
        }
      }

      .labelBox {
        display: flex;
        align-items: center;

        .el-icon.el-tooltip__trigger {
          margin-left: 8px;
          margin-right: 12px;
        }
      }

      .upload-demo {
        position: relative;

        .el-upload {
          width: 100%;
        }

        .uploadBox {
          width: 100%;
          height: 50px;
          line-height: 50px;
          border: 1px dashed #189bfe;
          border-radius: 8px;
          background-color: rgba(24, 155, 254, .05);

          .upBtnBox {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #189bfe;

            .el-icon {
              margin-right: 10px;
              font-size: 18px;
            }
          }

          .none {
            display: none;
          }
        }

        .el-upload-list {
          position: absolute;
          top: 0;
          width: 90%;
          margin-left: 5%;
        }
      }
    }

    //.formItem {
    //  .el-form-item__content {
    //    display: flex;
    //  }
    //
    //  .widthBox {
    //    flex: 1;
    //  }
    //}
    .contentItem {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      > p,
      > div {
        margin-right: 10px;
        display: flex;
        align-items: center;
      }

      .contItemBox {
        align-items: start;

        .symbol {
          margin-right: 10px;
          margin-top: 30px;
          font-size: 20px;
          text-align: center;

          p {
            cursor: pointer;
            margin: 0;
          }

          .activeSymbol {
            color: #165DFF;
          }
        }

        .symbol2 {
          margin-top: 50px;
        }
      }

      .addIcon,
      .delIcon {
        font-size: 17px;
        color: #000;
        cursor: pointer;
      }

      .addBox {
        width: 160px;
        height: 160px;
        border: 1px dashed #000;
        margin: 10px 0 0 10px;
        text-align: center;
        line-height: 160px;
        font-size: 40px;
        color: #000;
        cursor: pointer;
      }

      .contItem {
        display: flex;
        flex-direction: column;
        margin: 10px 0px 10px 0;

        .el-select {
          width: 160px;
          height: 30px;
        }

        .contTime .el-input {
          width: 110px;
          height: 30px;
        }

        .el-input__wrapper {
          height: 30px;
          background-color: #f6f6f6;
          color: #ccc;
          box-shadow: 0 0 0 0;
        }

        .contBox {
          width: 140px;
          height: 100px;
          background-color: #f6f6f6;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 0 10px;
          margin: 10px 0;
          position: relative;

          .el-select {
            width: calc(100% - 17px);

            .el-input__inner {
              padding-left: 0;
              font-size: 12px;
            }
          }

          .delIcon {
            position: absolute;
            top: 5px;
            right: 5px;
            color: #ccc;
            z-index: 1;
          }

          .center {
            p {
              color: #000;
            }

            //.val .el-input__wrapper {
            //  box-shadow: 0 0 0 0;
            //  background-color: #f6f6f6;
            //}
            .val .el-input__inner {
              font-size: 24px;
              color: #000;
            }

            .val .el-input__inner::placeholder {
              font-size: 12px;
              vertical-align: middle;
            }
          }

          .unit {
            text-align: right;
          }
        }

        .contItem:hover .delIcon {
          display: block;
        }
      }
    }
  }

  .groupClass {
    width: 20px;
    height: 20px;
  }


  //选择设备类型弹窗
  .typeDialogVisible {
    .selectPox {
      display: flex;
      justify-content: space-around;
      padding: 32px 0;

      .pox {
        display: flex;
        align-items: center;
        width: 240px;
        height: 102px;
        background: linear-gradient(90deg, #FDFEFF 0%, #F6FAFF 100%);
        border-radius: 4px;
        border: 1px solid #E6EAF0;

        img {
          width: 80px;
          height: 80px;
          margin-right: 24px;
          margin-left: 20px;
        }
      }

      .activePox {
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
      }
    }
  }


  .bindWarnVisible {
    .el-dialog__header {
      border-bottom: 1px solid #efefef;
      margin: 0;
      padding: 16px 20px;

    }

    .el-dialog__footer {
      border-top: 1px solid #efefef;
      margin: 0;
      padding: 16px 20px;
    }

    .el-form {
      display: flex;
      flex-wrap: wrap;
    }

    .el-form-item {
      //width: 40%;
      display: flex;
      margin-bottom: 25px;

      .el-form-item__content {
        align-items: start;
      }


      .el-select {
        width: 100%;
      }

      .el-input, .el-select {
        width: 220px;
      }

      .treeSelect .el-input, .el-select {
        width: 100%;
        max-width: 700px;
      }
    }

    .rowItem {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 18px;

      > span {
        margin-right: 10px;
      }

      .el-form-item {
        margin-bottom: 0 !important;
        margin-right: 16px;

        .item {
          width: 220px;
        }
      }

      .data {
        .el-input.el-input--suffix {
          width: 220px;
        }

        .item .item {
          width: 100px;

          .el-input.el-input--suffix {
            width: 100px;
          }
        }
      }

      .addIcon, .delIcon {
        font-size: 18px;
        margin-right: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>
